
















































import Vue from "vue";
import { mapState } from "vuex";
import { Lang } from "@/store";

export default Vue.extend({
  data() {
    return {
      Lang: Object(Lang)
    };
  },
  computed: mapState(["lang"]),
  methods: {
    setLanguage: function (lang: Lang) {
      this.$store.commit("setLang", lang);
    }
  }
});
